module.exports = __webpack_public_path__ + "static/media/eason.7a159dca.png";